export const dataBaseColumns = [
  { value: 'material', label: 'Material' },
  { value: 'format', label: 'Formato' },
  { value: 'finishing', label: 'Acabamento' },
  { value: 'fabrication', label: 'Fabricação' },
  { value: 'heatTreatment', label: 'Tratamento térmico' },
  { value: 'quantity', label: 'Quantidade (pç)' },
  { value: 'totalWeight', label: 'Peso total (kg)' },
  { value: 'lengthInMm', label: 'Comprimento (mm)' },
  { value: 'dimension1', label: 'Dimensão 1' },
  { value: 'dimension2', label: 'Dimensão 2' },
  { value: 'costPerKg', label: 'Custo por Kg' },
  { value: 'costPerMm', label: 'Custo por mm' },
  { value: 'totalCmc', label: 'CMC total' },
  { value: 'originCountry', label: 'País de Origem' },
  { value: 'supplier', label: 'Fornecedor' },
  { value: 'stockStreet', label: 'Rua' },
  { value: 'shelf', label: 'Prateleira' },
  { value: 'stockLocation', label: 'Localização' },
  { value: 'density', label: 'Densidade' },
  { value: 'totalCost', label: 'Custo total' },
  { value: 'code', label: 'Código' },
  { value: 'ncm', label: 'NCM' },
  { value: 'receivedDate', label: 'Data de recebimento' },
  { value: 'heatNumber', label: 'Nº de corrida' },
  { value: 'trackingNumber', label: 'Nº de rastreamento' },
  { value: 'family', label: 'Família' },
  { value: 'description', label: 'Descrição' },
  { value: 'characteristic', label: 'Característica' },
  { value: 'purchaseOrder', label: 'Ordem de compra' },
  { value: 'measurementUnit', label: 'Unidade' },
]
